<template>
    <div :class="this.currentPage === 'login' ? 'login-page' : ''">
        <v-container fluid>
            <v-card
                v-if="currentPage === 'login'"
                class="mx-auto pb-5 mt-5"
                style="max-width: 600px"
                rounded="lg"
                elevation="24"
                variant="elevated"
            >
                <v-toolbar
                    style="
                        background: linear-gradient(
                            90deg,
                            #3b3d4d 21%,
                            #242939
                        );
                        color: white;
                    "
                    dark
                    prominent
                    class="mb-5"
                >
                    <p class="text-h6 pl-5">
                        {{ translations.PunchSystemLogin }}
                    </p>
                </v-toolbar>
                <v-row>
                    <v-col
                        :cols="isSmallScreen ? '12' : '6'"
                        class="d-flex pl-10 pr-5"
                    >
                        <v-img
                            max-height="150"
                            :src="logoPath"
                            class="my-auto"
                        ></v-img>
                    </v-col>
                    <v-col class="pr-10 pl-5">
                        <form @submit.prevent="login">
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        :label="translations.UserID"
                                        variant="outlined"
                                        v-model="form.username"
                                        type="text"
                                        color="primary"
                                    >
                                        <template v-slot:prepend-inner>
                                            <font-awesome-icon
                                                icon="fa-solid fa-user"
                                                class="mr-1"
                                            />
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        :label="translations.Password"
                                        variant="outlined"
                                        v-model="form.password"
                                        :type="
                                            showPassword ? 'text' : 'password'
                                        "
                                        color="primary"
                                        :append-icon="
                                            showPassword
                                                ? 'mdi:mdi-eye'
                                                : 'mdi:mdi-eye-off'
                                        "
                                        @click:append="
                                            showPassword = !showPassword
                                        "
                                    >
                                        <template v-slot:prepend-inner>
                                            <font-awesome-icon
                                                icon="fa-solid fa-key"
                                                class="mr-1"
                                            />
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-btn
                                        variant="elevated"
                                        color="primary"
                                        class="w-100"
                                        type="submit"
                                        :loading="formProcessing"
                                    >
                                        {{ translations.LogIn }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </form>
                    </v-col>
                </v-row>
            </v-card>
            <div v-if="currentPage === 'home'" class="fill-height">
                <PunchSystem :company="company" @showSnackbar="showSnackbar" />
            </div>
        </v-container>

        <v-snackbar
            v-model="snackbar.show"
            :text="snackbar.msg"
            :color="snackbar.color"
            timeout="3000"
        />
    </div>
</template>

<script>
import GuestLayout from "../../Layouts/GuestLayout.vue";
import axios from "axios";
import { filterTranslations } from "../../PunchSystemTranslations.js";

import { defineAsyncComponent } from "vue";
const PunchSystem = defineAsyncComponent(() =>
    import("../../components/GlobalPunchSystem/PunchSystem/PunchSystem.vue")
);

export default {
    layout: [GuestLayout],
    components: {
        PunchSystem,
    },
    data() {
        return {
            company: null,
            showPassword: false,
            form: {
                username: null,
                password: null,
            },
            formProcessing: false,
            isSmallScreen: false,
            currentPage: "login",
            snackbar: {
                show: false,
                msg: "",
                color: "",
            },
        };
    },
    computed: {
        logoPath() {
            if (this.company == "DBR") {
                return "/images/DBR_Connect.png";
            } else if (this.company == "DMX") {
                return "/images/DMX_Connect.png";
            }
        },
        translations() {
            let userLanguage;
            if (this.$page.props.auth.check) {
                userLanguage = this.$page.props.auth.user.language;
            } else {
                switch (this.company) {
                    case "DMX":
                        userLanguage = "spanish";
                        break;
                    case "DBR":
                        userLanguage = "portuguese";
                        break;
                    default:
                        userLanguage = "english";
                        break;
                }
            }
            return filterTranslations(userLanguage);
        },
    },
    beforeCreate() {},
    created() {
        this.updateScreenSize();
        window.addEventListener("resize", this.updateScreenSize);

        const lastDashIndex = window.location.href.lastIndexOf("-");
        if (lastDashIndex !== -1) {
            this.company = window.location.href.substring(lastDashIndex + 1);
        }
    },

    destroyed() {
        window.removeEventListener("resize", this.updateScreenSize);
    },
    methods: {
        async login() {
            this.formProcessing = true;
            try {
                await axios
                    .post(
                        route("api.globalPunchSystem.login", {
                            company: this.company,
                            user_id: this.form.username,
                            password: this.form.password,
                        })
                    )
                    .then((response) => {
                        let msgData = {
                            msg:
                                response.data.message === 0
                                    ? this.translations.LogInMsg
                                    : response.data.message,
                            color: "success",
                        };
                        this.showSnackbar(msgData);
                        this.currentPage = "home";
                    })
                    .catch((error) => {
                        let msg;
                        switch (error.response.data.message) {
                            case 1:
                                msg = this.translations.MissingRequiredFields;
                                break;
                            default:
                                msg = this.translations.LogInError;
                                break;
                        };
                        let msgData = {
                            msg: msg,
                            color: "error",
                        };
                        this.showSnackbar(msgData);
                    })
                    .finally(() => {
                        this.formProcessing = false;
                    });
            } catch (err) {
                console.log(err);
            }
        },
        updateScreenSize() {
            this.isSmallScreen = window.innerWidth <= 600;
        },
        showSnackbar(data) {
            this.snackbar = {
                show: true,
                msg: data.msg,
                color: data.color,
            };
        },
    },
};
</script>
<style scoped>
.login-page {
    background-image: url("/images/World-map.jpg");
    background-size: cover;
    background-position: center;
    height: 93vh;
}
:deep(.v-snackbar__content) {
    font-size: 1.25em;
    text-align: center;
}
</style>
